(function(module) {
try { module = angular.module("served.templates"); }
catch(err) { module = angular.module("served.templates", []); }
module.run(["$templateCache", function($templateCache) {
  $templateCache.put("app/source/options.view.html",
    "<div ui-view flex>\n" +
    "    <md-card class=\"nozzle-banner-container\">\n" +
    "        <div class=\"container-md middlize stretch-all\"><div layout=\"column\" ng-cloak class=\"md-inline-form\">\n" +
    "            <md-content layout-padding>\n" +
    "                <form name=\"unitsSelector\" class=\"selector-form\">\n" +
    "                    <div class=\"break-line-30\"></div>\n" +
    "\n" +
    "                    <!-- Units -->\n" +
    "                    <div layout-gt-xs=\"row\">\n" +
    "                        <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                            <label>Application Rate</label>\n" +
    "                            <md-select ng-model=\"vm.appRate\" ng-change=\"vm.setSpacingUnit()\">\n" +
    "                                <md-option ng-repeat=\"ar in vm.units.applicationRate\" ng-value=\"{{ar}}\" ng-selected=\"$first\">\n" +
    "                                    {{ar.label}}\n" +
    "                                </md-option>\n" +
    "                            </md-select>\n" +
    "                        </md-input-container>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div layout-gt-xs=\"row\">\n" +
    "                        <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                            <label>Ground Speed</label>\n" +
    "                            <md-select ng-model=\"vm.groundSpeed\" ng-change=\"vm.setSpacingUnit()\">\n" +
    "                                <md-option ng-repeat=\"gs in vm.units.groundSpeed\" ng-value=\"{{gs}}\" ng-selected=\"$first\">\n" +
    "                                    {{gs.abbr}} ({{gs.label.toLowerCase()}})\n" +
    "                                </md-option>\n" +
    "                            </md-select>\n" +
    "                        </md-input-container>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"break-line-30\"></div>\n" +
    "\n" +
    "                    <!-- Next -->\n" +
    "                    <div layout-gt-xs=\"row\">\n" +
    "                        <div class=\"md-block\" flex>\n" +
    "                            <md-button type=\"submit\" ui-sref=\"selector\" ng-click=\"vm.setUnits()\" class=\"toroNavigationBtn md-warn\" style=\"width: 100%;\">Next</md-button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </form>\n" +
    "            </md-content></div>\n" +
    "        </div>\n" +
    "    </md-card>\n" +
    "</div>\n" +
    "");
}]);
})();

(function(module) {
try { module = angular.module("served.templates"); }
catch(err) { module = angular.module("served.templates", []); }
module.run(["$templateCache", function($templateCache) {
  $templateCache.put("app/source/results.view.html",
    "<div ui-view=\".results\" flex>\n" +
    "    <md-content layout-padding>\n" +
    "        <div class=\"view-container middlize\" layout=\"column\">\n" +
    "            <div class=\"break-line-30\"></div>\n" +
    "            <h2>{{\"titles.search-criteria\" | translate}}</h2>\n" +
    "            <div class=\"break-line-10\"></div>\n" +
    "            <div layout=\"row\" layout-align=\"left center\">\n" +
    "                <md-icon md-font-icon=\"fa fa-cog\"></md-icon>\n" +
    "                <div class=\"fade-black\" flex-gt-xs>{{vm.query.appRate.value}} {{vm.appRate.abbr}}, {{vm.query.groundSpeed.value}} {{vm.groundSpeed.abbr}}, {{vm.query.spacing.value}}{{vm.query.spacing.abbr}} {{\"labels.nozzle-spacing\" | translate}}, {{\"nozzles.mode.\" + vm.query.mode.toLowerCase() | translate}}, {{\"nozzles.mode.drift-control\" | translate}} - <span ng-show=\"vm.query.dc\">{{\"labels.yes\" | translate}}</span><span ng-show=\"!vm.query.dc\">{{\"labels.no\" | translate}}</span></div>             \n" +
    "                <div class=\"md-block\" flex-xs>\n" +
    "                    <md-button type=\"button\" class=\"toro-navigation-btn md-warn no-print\" ng-click=\"vm.goBack()\">{{\"labels.buttons.change\" | translate}}</md-button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div layout=\"row\" layout-align=\"left center\">\n" +
    "                <md-icon md-font-icon=\"fa fa-calculator\"></md-icon>\n" +
    "                <div class=\"fade-black\" flex>{{\"labels.calculated-flow-rate\" | translate}} <strong>{{vm.nozzleFlowRate.value}} {{vm.nozzleFlowRate.unit}}</strong></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"break-line-30\"></div>\n" +
    "            <div class=\"break-line-10\"></div>\n" +
    "            <md-divider></md-divider>\n" +
    "            <h2 class=\"title\">{{\"titles.recommended-nozzles\" | translate}}</h2>\n" +
    "            <md-content>\n" +
    "                <md-list>\n" +
    "                    <md-list-item class=\"md-2-line\" ng-repeat=\"nozzle in vm.results\" ng-click=\"null\">\n" +
    "                        <div class=\"md-avatar-container\">\n" +
    "                            <img ng-src=\"./images/{{nozzle.image}}\" class=\"md-avatar\" alt=\"{{nozzle.name}}\"/>\n" +
    "                        </div>\n" +
    "                        <div class=\"md-list-item-text\" layout=\"column\">\n" +
    "                            <h3>{{\"nozzles.colors.\" + vm.recommendedColor | translate}} {{nozzle.name}} <span ng-show=\"nozzle.name != (nozzle.nameToTranslate | translate)\">({{nozzle.nameToTranslate | translate}})</span></h3>\n" +
    "                            <p><span class=\"key\">{{\"labels.part-number\" | translate}}</span> <span>{{nozzle.partNumber}}</span></p>\n" +
    "                            <p></p>\n" +
    "                            <p><span class=\"key\">{{\"labels.avg-flow-rate\" | translate}}</span> {{vm.colorGpM}}{{vm.nozzleFlowRate.unit}}</p>\n" +
    "                            <p>{{nozzle.description | translate}}</p>\n" +
    "                        </div>\n" +
    "                    </md-list-item>\n" +
    "                </md-list>\n" +
    "            </md-content>\n" +
    "            \n" +
    "            <div class=\"break-line-10\"></div>\n" +
    "            <md-divider></md-divider>\n" +
    "            <h2 class=\"title\">{{\"titles.recommended-filter\" | translate}}</h2>\n" +
    "            <md-content>\n" +
    "                <md-list>\n" +
    "                    <md-list-item class=\"md-2-line\" ng-repeat=\"m in vm.meshes\" ng-click=\"null\">\n" +
    "                        <div class=\"md-avatar-container\">\n" +
    "                            <img ng-src=\"./images/{{vm.filters[m].image}}\" class=\"md-avatar\" alt=\"Mesh {{m}}\"/>\n" +
    "                        </div>\n" +
    "                        <div class=\"md-list-item-text\" layout=\"column\">\n" +
    "                            <h3>{{\"labels.mesh\" | translate}} - {{m}}</h3>\n" +
    "                            <p>{{\"labels.part-number\" | translate}} <span>{{vm.filters[m].partNumber}}</span></p>\n" +
    "                        </div>\n" +
    "                    </md-list-item>\n" +
    "                </md-list>\n" +
    "            </md-content>\n" +
    "\n" +
    "            <div class=\"break-line-10\"></div>\n" +
    "            <md-divider></md-divider>\n" +
    "            <h2 class=\"title\">{{\"titles.recommended-strainer\" | translate}}</h2>\n" +
    "            <md-content class=\"last-print-element\">\n" +
    "                <md-list>\n" +
    "                    <md-list-item class=\"md-2-line\" ng-click=\"null\">\n" +
    "                        <div class=\"md-avatar-container\">\n" +
    "                            <img ng-src=\"./images/8079-50_cat_50_tip_strainer.png\" class=\"md-avatar\" alt=\"Tip Strainer 50\" />\n" +
    "                        </div>\n" +
    "                        <div class=\"md-list-item-text\" layout=\"column\">\n" +
    "                            <h3>{{\"labels.tip-strainer\" | translate}} - 50</h3>\n" +
    "                            <p>{{\"labels.part-number\" | translate}} <span>120-0699</span></p>\n" +
    "                        </div>\n" +
    "                    </md-list-item>\n" +
    "                </md-list>\n" +
    "            </md-content>\n" +
    "\n" +
    "            <span class=\"no-print\">\n" +
    "              \n" +
    "              <div class=\"break-line-10\"></div>\n" +
    "              <md-divider></md-divider>\n" +
    "              <div class=\"break-line-30\"></div>\n" +
    "\n" +
    "              <div class=\"break-line-30\"></div>\n" +
    "\n" +
    "              <a ng-href=\"{{'nozzles.brochure-link' | translate}}\" target=\"_blank\" class=\"brochure-link\">\n" +
    "                <md-icon md-font-icon=\"fa fa-lg fa-file-pdf-o\"></md-icon>\n" +
    "                <span>{{\"labels.brochure\" | translate}}</span>\n" +
    "              </a>\n" +
    "              \n" +
    "              <div layout=\"row\" layout-align=\"center center\">\n" +
    "                <div class=\"md-block nav-btn-lg\">\n" +
    "                  <md-button type=\"button\" data-rel=\"external\" class=\"md-warn md-raised toro-red-btn\" ng-click=\"vm.generateEmailTemplate()\"\n" +
    "                             ng-href=\"{{vm.mailto}}\">{{\"labels.buttons.email\" | translate}}\n" +
    "                  </md-button>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div ng-messages=\"vm.noemail\" ng-if=\"vm.noemail.warn\">\n" +
    "                <div ng-message=\"!vm.noemail.flag\" ng-show=\"!vm.noemail.flag\" class=\"isa_info\"\n" +
    "                     ng-click=\"vm.dismissWarning()\" layout=\"row\" layout-align=\"center center\">\n" +
    "                  <i class=\"fa fa-info-circle\" flex=\"1\"></i>\n" +
    "                  <div flex>{{\"labels.spec-messages.no-email-info\" | translate}}</div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </md-content>\n" +
    "</div>\n" +
    "");
}]);
})();

(function(module) {
try { module = angular.module("served.templates"); }
catch(err) { module = angular.module("served.templates", []); }
module.run(["$templateCache", function($templateCache) {
  $templateCache.put("app/source/selector.view.html",
    "<div ui-view>\n" +
    "<md-card class=\"nozzle-banner-container\">\n" +
    "<img ng-src=\"./images/nozzles-banner.png\" src=\"images/nozzles-banner.png\" class=\"md-card-image\"/>\n" +
    "<md-content>\n" +
    "    <div layout=\"column\" class=\"middlize container-md\" ng-if=\"onHomepage\" ng-cloak ng-click=\"vm.changePreferences = false\">\n" +
    "        <div class=\"stretch-all\">\n" +
    "        <form name=\"selectorOptions\" class=\"md-inline-form\" layout-padding novalidate>\n" +
    "        <h2 class=\"title\">{{\"titles.application-mode\" | translate}}</h2>\n" +
    "        \n" +
    "        <!-- Mode -->\n" +
    "        <div layout=\"row\" layout-align=\"center center\">\n" +
    "            <md-input-container md-is-error=\"selectorOptions.mode.$invalid && selectorOptions.$submitted\">\n" +
    "            <md-radio-group ng-model=\"vm.query.mode\" ng-change=\"vm.calculateFlowRate(this)\" required\n" +
    "                            flex-xs name=\"mode\" layout-gt-xs=\"row\" layout-xs=\"column\" layout-align-gt-xs=\"space-between center\">\n" +
    "                <md-radio-button value=\"Systemic\" class=\"md-primary mode-radio-btn\">{{\"nozzles.mode.systemic\" | translate}}</md-radio-button>\n" +
    "                <md-radio-button value=\"Contact\" class=\"md-primary mode-radio-btn\">{{\"nozzles.mode.contact\" | translate}}</md-radio-button>\n" +
    "                \n" +
    "                <!-- Drift Control -->\n" +
    "		<md-checkbox md-no-ink aria-label=\"Drift Control\"\n" +
    "                             ng-model=\"vm.query.dc\"\n" +
    "                             class=\"md-primary\"\n" +
    "                             ng-change=\"vm.calculateFlowRate(this)\"\n" +
    "                             checked>{{\"nozzles.mode.drift-control\" | translate}}</md-checkbox>\n" +
    "            </md-radio-group>\n" +
    "            \n" +
    "            <div ng-messages=\"selectorOptions.mode.$error\" ng-if=\"selectorOptions.$submitted\">\n" +
    "                <div ng-message=\"required\" ng-show=\"selectorOptions.mode.$error.required\">{{\"labels.spec-messages.nozzle-type\" | translate}}</div>\n" +
    "            </div>\n" +
    "            </md-input-container>\n" +
    "        </div>\n" +
    "        \n" +
    "        <md-divider></md-divider>\n" +
    "        <h2 class=\"title\">{{\"titles.flow-rate-calculation\" | translate}}</h2>\n" +
    "        \n" +
    "        <div layout=\"row\" layout-align=\"center center\" class=\"fade-black preferences\" ng-click=\"$event.stopPropagation(); vm.changePreferences = !vm.changePreferences;\">\n" +
    "            <div>\n" +
    "                <md-icon class=\"cog-icon\" md-font-icon=\"fa fa-cog fa-lg\"></md-icon>\n" +
    "                <span class=\"change-preferences-label\">{{\"labels.change-preferences\" | translate}}</span>\n" +
    "                <md-icon class=\"caret-icon\" md-font-icon=\"{{vm.changePreferences ? 'fa fa-lg fa-caret-up' : 'fa fa-lg fa-caret-down'}}\"></md-icon>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        \n" +
    "        <md-card class=\"change-preferences-block\" md-no-ink ng-show=\"vm.changePreferences\" ng-hide=\"!vm.changePreferences\"\n" +
    "                 ng-click=\"$event.stopPropagation();\" class=\"ng-animate-disabled\">\n" +
    "            <md-card-content ng-cloak>\n" +
    "                \n" +
    "            <!-- Units -->\n" +
    "            <div layout-gt-xs=\"row\">\n" +
    "                <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                    <label>{{\"labels.application-rate\" | translate}}</label>\n" +
    "                    <md-select ng-model=\"vm.appRate\" ng-change=\"vm.setAppRateUnit()\" class=\"ng-animate-disabled\">\n" +
    "                        <md-option ng-repeat=\"rate in vm.units.applicationRate\" ng-value=\"rate\" class=\"ng-animate-disabled\">\n" +
    "                            {{rate.label | translate}}\n" +
    "                        </md-option>\n" +
    "                    </md-select>\n" +
    "                </md-input-container>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Spacing -->\n" +
    "            <div layout-gt-xs=\"row\">\n" +
    "                <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                    <label>{{\"labels.ground-speed\" | translate}}</label>\n" +
    "                    <md-select ng-model=\"vm.groundSpeed\" ng-change=\"vm.setSpeedUnit()\" class=\"ng-animate-disabled\">\n" +
    "                        <md-option ng-repeat=\"speed in vm.units.groundSpeed\" ng-value=\"speed\" class=\"ng-animate-disabled\">\n" +
    "                            {{speed.abbr}} ({{speed.label | translate}})\n" +
    "                        </md-option>\n" +
    "                    </md-select>\n" +
    "                </md-input-container>\n" +
    "            </div>\n" +
    "            \n" +
    "            </md-card-content>\n" +
    "        </md-card>\n" +
    "\n" +
    "        <!-- Inputs -->\n" +
    "        <div class=\"unit-inputs-container\" ng-cloak>\n" +
    "            <!-- Application Rate -->\n" +
    "            <div layout-gt-xs=\"row\" class=\"md-mid-row\">\n" +
    "                <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                    <label>{{\"labels.application-rate\" | translate}}</label>\n" +
    "                    <md-icon md-font-icon=\"fa fa-tint\"></md-icon>\n" +
    "                    <input name=\"appRate\"\n" +
    "                           placeholder=\"{{'labels.enter-in' | translate}} {{vm.appRate.label | translate}}\" required\n" +
    "                           ng-change=\"vm.calculateFlowRate(this)\"\n" +
    "                           ng-model=\"vm.query.appRate.value\" type=\"number\"\n" +
    "                           ng-min=\"vm.query.appRate.min\" ng-max=\"vm.query.appRate.max\" min=\"0\"\n" +
    "                           step=\"0.1\">\n" +
    "                    <div ng-messages=\"selectorOptions.appRate.$error\" class=\"ng-messages\"\n" +
    "                         ng-show=\"selectorOptions.appRate.$invalid && (selectorOptions.$submitted  || selectorOptions.appRate.$touched)\">\n" +
    "                        <div ng-message=\"min\" ng-message=\"max\" ng-message=\"number\" ng-show=\"selectorOptions.appRate.$error.min || selectorOptions.appRate.$error.max || selectorOptions.appRate.$error.number\">{{\"labels.spec-messages.out-of-range\" | translate}} {{vm.query.appRate.min}} {{vm.query.appRate.abbr}} / {{vm.query.appRate.max}} {{vm.query.appRate.abbr}}</div>\n" +
    "                    </div>\n" +
    "                </md-input-container>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Ground Speed -->\n" +
    "            <div layout-gt-xs=\"row\" class=\"md-mid-row\">\n" +
    "                <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                    <label>{{\"labels.ground-speed\" | translate}}</label>\n" +
    "                    <md-icon md-font-icon=\"fa fa-tachometer\"></md-icon>\n" +
    "                    <input name=\"groundSpeed\" placeholder=\"{{'labels.enter-in' | translate}} {{vm.groundSpeed.label | translate}}\" type=\"number\" required\n" +
    "                           ng-change=\"vm.calculateFlowRate(this)\" ng-model=\"vm.query.groundSpeed.value\"\n" +
    "                           min=\"0\" ng-min=\"vm.query.groundSpeed.min\" ng-max=\"vm.query.groundSpeed.max\" step=\"0.5\">\n" +
    "                    <div ng-messages=\"selectorOptions.groundSpeed.$error\" class=\"ng-messages\"\n" +
    "                         ng-show=\"selectorOptions.groundSpeed.$invalid && (selectorOptions.$submitted || selectorOptions.groundSpeed.$touched)\">\n" +
    "                        <div ng-message=\"min\" ng-message=\"max\" ng-message=\"number\" ng-show=\"selectorOptions.groundSpeed.$error.min || selectorOptions.groundSpeed.$error.max || selectorOptions.groundSpeed.$error.number\">{{\"labels.spec-messages.out-of-range\" | translate}} {{vm.query.groundSpeed.min}} {{vm.query.groundSpeed.abbr}} / {{vm.query.groundSpeed.max}} {{vm.query.groundSpeed.abbr}}</div>\n" +
    "                    </div>\n" +
    "                </md-input-container>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Spacing -->\n" +
    "            <div layout-gt-xs=\"row\">\n" +
    "                <md-input-container class=\"md-block\" flex-gt-xs>\n" +
    "                    <label>{{\"labels.nozzle-spacing\" | translate}}</label>\n" +
    "                    <md-icon md-font-icon=\"fa fa-arrows-h\"></md-icon>\n" +
    "                    <input name=\"spacing\" class=\"disabled-spacing\" disabled ng-model=\"vm.spacingViewValue\">\n" +
    "                </md-input-container>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <md-subheader ng-if=\"vm.calculated\" class=\"md-no-sticky\">{{\"labels.calculated-flow-rate\" | translate}} <strong>{{vm.nozzleFlowRate.value}}{{vm.nozzleFlowRate.unit}}</strong></md-subheader>\n" +
    "        <md-subheader ng-if=\"vm.calculated && vm.disableResults\"  class=\"md-primary\" ng-show=\"vm.disableResults\">{{\"labels.spec-messages.bad-criteria\" | translate}} <a ng-href=\"{{'nozzles.brochure-link' | translate}}\" target=\"_blank\" class=\"brochure-link-red\">{{\"labels.brochure\" | translate}}</a>.</md-subheader>\n" +
    "\n" +
    "        <!-- View Results -->\n" +
    "        <div layout-gt-xs=\"row\">\n" +
    "            <div class=\"md-block nav-btn-lg\" flex>\n" +
    "                <md-button type=\"submit\" ng-click=\"vm.showResults(this)\" ng-disabled=\"vm.disableResults\"\n" +
    "                           class=\"toro-navigation-btn md-warn\">\n" +
    "                    {{\"labels.buttons.view-results\" | translate}}\n" +
    "                </md-button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "</md-content>\n" +
    "</md-card>\n" +
    "</div>\n" +
    "");
}]);
})();
